import { Form, Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'

import { editProfile } from '../../redux/authSlice'
import { useAppHistory } from '../../utils/useAppHistory'
import { ErrorMessage } from '../auth/AuthWrappers'
import { Input, PasswordInput } from '../form/FormikWrappers'
import FormButtons from '../ui/FormButtons'
import { PageHeader } from '../ui/Headers'
import LoadingIndicator from '../ui/LoadingIndicator'
import { TopSafeAreaInsetPage } from '../ui/PageTemplate'
import SubmitButton from '../ui/SubmitButton'
import withRedirectToAuth from './withRedirectToAuth'

const formToUser = ({ email, password, announcements_email, name }, user) => ({
  email,
  password_confirmation: password,
  announcements_email,
  name: name || null,
  bio: user.bio || null,
  range: null,
})

const ChangeEmailPage = () => {
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth)
  const { t } = useTranslation()
  const history = useAppHistory()

  const handleEmailSubmit = (values, formikProps) => {
    dispatch(editProfile(formToUser(values, user))).then((action) => {
      if (action.error) {
        formikProps.setSubmitting(false)
      } else {
        history.push('/account/edit')
      }
    })
  }

  const validationSchema = Yup.object({
    email: Yup.string()
      .email()
      .required()
      .test(
        'is-different',
        t('form.error.must_be_different'),
        function (value) {
          return value !== user?.email
        },
      ),
    password: Yup.string().required(),
  })

  return (
    <TopSafeAreaInsetPage backPath="/account/edit">
      <PageHeader>{t('users.change_email')}</PageHeader>

      {user ? (
        <>
          <div style={{ marginBottom: '24px' }}>
            <label
              style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 'bold',
              }}
            >
              {t('users.current_email')}
            </label>
            <div style={{ padding: '8px 0' }}>{user.email}</div>
          </div>

          <Formik
            initialValues={{
              email: '',
              password: '',
              announcements_email: user.announcements_email,
              name: user.name || '',
            }}
            validationSchema={validationSchema}
            onSubmit={handleEmailSubmit}
          >
            {({ errors, isValid, isSubmitting }) => (
              <Form>
                <div>
                  <Input
                    name="email"
                    type="email"
                    label={t('users.new_email')}
                    autoComplete="email"
                    required
                  />
                  {errors.email && <ErrorMessage>{errors.email}</ErrorMessage>}
                  <PasswordInput
                    name="password"
                    label={t('glossary.password')}
                    autoComplete="current-password"
                    required
                  />
                </div>
                <FormButtons>
                  <SubmitButton
                    isSubmitting={isSubmitting}
                    disabled={!isValid}
                    label={t('users.change_email')}
                  />
                </FormButtons>
              </Form>
            )}
          </Formik>
        </>
      ) : (
        <LoadingIndicator vertical cover />
      )}
    </TopSafeAreaInsetPage>
  )
}

export default withRedirectToAuth(ChangeEmailPage)
